import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  courseTypeList: [],
  courseTypeDetails: null,
  courseDetails: null,
  courseDetailsError: null,
  courseType: [],
  favourites: [],
  uploadCoursesListLoading: false,
  uploadCoursesListSuccess: null,
  uploadCoursesListError: '',
  courseByCategoryAndSubCategory: [],
  coursesLoading: false,

  CourseMediumListLoading: false,
  CourseMediumList: {},
  CourseMediumListError: null,

  CourseMediumByIdLoading: false,
  CourseMediumByIdSuccess: {},
  CourseMediumByIdError: "",
  popularCourses: []
}

export const courseTypeSlice = createSlice({
  name: 'course-type',
  initialState,
  reducers: {
    getCourseTypes: (state, action) => {
      state.courseTypeList = action.payload;
    },
    getCourseTypeDetails: (state, action) => {
      state.courseTypeDetails = action.payload;
    },
    resetCourseType: (state) => {
      state.courseTypeDetails = null
      state.courseTypeList = []
    },
    getCourseDetails: (state, action) => {
      state.courseType = action.payload?.courseType?.length ? action.payload.courseType : []
      state.courseDetails = action.payload
    },
    getCourseDetailsError: (state, action) => {
      state.courseDetailsError = action.payload
    },
    resetCourseDetails: (state) => {
      state.courseDetails = null
      state.courseType = []
      state.favourites = []
    },
    setFavourites: (state, action) => {
      state.favourites = action.payload
    },
    setPopularCourses: (state, action) => {
      state.popularCourses = action.payload
    },
    setUploadedCoursesListLoading: (state, action) => {
      state.uploadCoursesListLoading = true
      state.uploadCoursesListSuccess = null
      state.uploadCoursesListError = ''
    },
    setUploadedCoursesListSuccess: (state, action) => {
      state.uploadCoursesListLoading = false
      state.uploadCoursesListSuccess = action.payload
      state.uploadCoursesListError = ''
    },
    setUploadedCoursesListError: (state, action) => {
      state.uploadCoursesListLoading = false
      state.uploadCoursesListSuccess = null
      state.uploadCoursesListError = action.payload
    },
    setCoursesLoading: (state, action) => {
      state.coursesLoading = true
    },
    setCourses: (state, action) => {
      state.coursesLoading = false
      state.courseByCategoryAndSubCategory = action.payload.data.map((item) => ({ ...item, value: item.id, label: item.name }))
    },
    resetCourses: (state, action) => {
      state.courseByCategoryAndSubCategory = []
    },

    getCourseMediumListLoading: (state, action) => {
      state.CourseMediumListLoading = true
    },
    getCourseMediumListSuccess: (state, action) => {
      state.CourseMediumListLoading = false
      state.CourseMediumList = action.payload
    },

    getCourseMediumListError: (state, action) => {
      state.CourseMediumListLoading = false
      state.CourseMediumList = {}
      state.CourseMediumListError = action.payload.message
    },
    getCourseMediumByIdLoading: (state, action) => {
      state.CourseMediumByIdLoading = true


    },
    getCourseMediumByIdSuccess: (state, action) => {
      state.CourseMediumByIdLoading = false
      state.CourseMediumByIdSuccess = action.payload.data
      state.CourseMediumByIdError = ""

    },
    getCourseMediumByIdError: (state, action) => {
      state.CourseMediumByIdLoading = false
      state.CourseMediumByIdSuccess = {}
      state.CourseMediumByIdError = action.payload.message


    },
    resetCourseMediumDetails: (state, action) => {
      state.CourseMediumByIdLoading = false
      state.CourseMediumByIdSuccess = {}

    },
    resetFavouriteCourses: (state, action) => {
      state.favourites = '';
    },
    resetPopularCourses: (state, action) => {
      state.popularCourses = '';
    },
  },
})

// Action creators are generated for each case reducer function
export const { resetCourses, setCourses, setCoursesLoading, getCourseTypes,
  getCourseTypeDetails, resetCourseType, getCourseDetails, getCourseDetailsError,
  resetCourseDetails, setFavourites, setPopularCourses, resetPopularCourses,
  setUploadedCoursesListLoading,
  setUploadedCoursesListSuccess,
  setUploadedCoursesListError,
  getCourseMediumListLoading,
  getCourseMediumListSuccess,
  getCourseMediumListError,
  getCourseMediumByIdLoading,
  getCourseMediumByIdSuccess,
  getCourseMediumByIdError,
  resetCourseMediumDetails,
  resetFavouriteCourses
} = courseTypeSlice.actions

export default courseTypeSlice.reducer;